import {
  PaymentPartnerType,
  Product,
  TransactionAmount,
  TransactionItem,
  TransactionState,
} from '../../../../codegen/transactions';
import { ServiceType } from '../../../../codegen/vehicles';
import { Transaction, Vehicle } from '../../../../models';
import { RowData } from '../../../../components/table/Table';

export type TransactionRow = {
  vehicle?: Vehicle;
  service: ServiceType;
  products: Product[];
  transactionDate?: string;
  billingPartner: PaymentPartnerType;
  serviceCardLastFourDigits: string;
  totalPrice?: TransactionAmount;
  totalPriceConverted?: TransactionAmount;
  state: TransactionState;
};

const mapTransactionAmount = (t: Transaction): TransactionAmount | undefined =>
  t.state === TransactionState.Completed
    ? t.completionAmount
    : t.deliveryAmount;

const mapProducts = (items: TransactionItem[] | undefined = []): Product[] =>
  items.reduce<Product[]>((acc, item) => {
    if (item.product) {
      acc.push(item.product);
    }
    return acc;
  }, []);

const mapTransactionToRow = (t: Transaction): RowData<TransactionRow> => ({
  key: t.id,
  vehicle: t.vehicle,
  service: t.serviceType,
  products: mapProducts(t.items),
  transactionDate: t.displayDate,
  billingPartner: t.paymentDetails.paymentPartner,
  serviceCardLastFourDigits: t.paymentDetails.lastFourDigits,
  totalPrice: mapTransactionAmount(t),
  totalPriceConverted: t.dashboardAmount,
  state: t.state,
});

export const mapTransactionsToRows = (
  transactions: Transaction[],
): RowData<TransactionRow>[] => transactions.map(mapTransactionToRow);
